import axios, { AxiosError } from "axios";
const ConsignmentMarketplaceFeesResource = {
    get(consignmentId, feeId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/consignments/${consignmentId}/marketplace-fees/${feeId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    list(consignmentId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/consignments/${consignmentId}/marketplace-fees`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(consignmentId, request, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/consignments/${consignmentId}/marketplace-fees`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(consignmentId, feeId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/consignments/${consignmentId}/marketplace-fees/${feeId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    delete(consignmentId, feeId, resultFunc, errorFunc, finallyFunc) {
        axios.delete(`/admin/v1/consignments/${consignmentId}/marketplace-fees/${feeId}`)
            .then(( /*response*/) => resultFunc())
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default ConsignmentMarketplaceFeesResource;
